"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveInnerMobileTray = exports.useInnerMobileMenu = exports.useSignInMobileTray = exports.useLocaleMobileTray = exports.useMobileMenu = void 0;
const react_1 = require("react");
const navActions_1 = require("../context/navActions");
const navContext_1 = require("../context/navContext");
const useMobileMenu = () => {
    const { state, dispatch } = (0, react_1.useContext)(navContext_1.NavContext);
    const setMobileMenuOpen = (open) => {
        dispatch({ type: navActions_1.ActionTypes.SET_MOBILE_OPEN, value: open });
    };
    return (0, react_1.useMemo)(() => {
        return {
            mobileMenuOpen: state.mobileMenuOpen,
            setMobileMenuOpen,
        };
    }, [state.mobileMenuOpen]);
};
exports.useMobileMenu = useMobileMenu;
const useLocaleMobileTray = () => {
    const { state, dispatch } = (0, react_1.useContext)(navContext_1.NavContext);
    const setMenuOpen = (open) => {
        dispatch({ type: navActions_1.ActionTypes.SET_MOBILE_LOCALE_OPEN, value: open });
    };
    return (0, react_1.useMemo)(() => {
        return {
            menuOpen: state.mobileLocaleOpen,
            setMenuOpen,
        };
    }, [state.mobileLocaleOpen]);
};
exports.useLocaleMobileTray = useLocaleMobileTray;
const useSignInMobileTray = () => {
    const { state, dispatch } = (0, react_1.useContext)(navContext_1.NavContext);
    const setMenuOpen = (open) => {
        dispatch({ type: navActions_1.ActionTypes.SET_MOBILE_SIGNIN_OPEN, value: open });
    };
    return (0, react_1.useMemo)(() => {
        return {
            menuOpen: state.mobileSigninOpen,
            setMenuOpen,
        };
    }, [state.mobileSigninOpen]);
};
exports.useSignInMobileTray = useSignInMobileTray;
const useInnerMobileMenu = () => {
    const { state, dispatch } = (0, react_1.useContext)(navContext_1.NavContext);
    const setInnerMobileMenu = (menuId) => {
        dispatch({ type: navActions_1.ActionTypes.SET_INNER_MOBILE_ACTIVE_MENU, value: menuId });
    };
    return (0, react_1.useMemo)(() => {
        return {
            innerMobileMenu: state.innerMobileActiveMenu,
            setInnerMobileMenu,
        };
    }, [state.innerMobileActiveMenu]);
};
exports.useInnerMobileMenu = useInnerMobileMenu;
const useActiveInnerMobileTray = (mobileTrayId) => {
    const { innerMobileMenu, setInnerMobileMenu } = (0, exports.useInnerMobileMenu)();
    const menuOpen = innerMobileMenu === mobileTrayId;
    const setMenuOpen = (0, react_1.useCallback)((open) => {
        if (open) {
            setInnerMobileMenu(mobileTrayId);
        }
        else {
            setInnerMobileMenu("");
        }
    }, [setInnerMobileMenu, mobileTrayId]);
    return {
        menuOpen,
        setMenuOpen,
    };
};
exports.useActiveInnerMobileTray = useActiveInnerMobileTray;
//# sourceMappingURL=mobile.hooks.js.map